
  import {
    defineComponent
  } from 'vue'

  export default defineComponent({
    name: 'MesProjetAcademiques',
    components: {},
    setup() {
      /*   */
    }
  })
